export default function validateDob(dobValue: string) {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  const dobDate = new Date(dobValue + "T00:00");
  dobDate.setHours(0, 0, 0, 0);

  const minDate = new Date("1753-01-01T00:00");

  return minDate <= dobDate && dobDate <= currentDate;
}
